export default __webpack_public_path__ + "static/media/Anthe_app_mobile.baefc875.png";